// Trailer records (manually added — trailers aren't tracked devices).
import { openDb } from './loadStore';

const STORE = 'trailers';

function tx(mode, fn) {
  return openDb().then((db) => new Promise((resolve, reject) => {
    const t = db.transaction(STORE, mode);
    const r = fn(t.objectStore(STORE));
    t.oncomplete = () => resolve(r && r.result !== undefined ? r.result : r);
    t.onerror = () => reject(t.error);
  }));
}

export function emptyTrailer() {
  return { id: null, unit: '', type: 'Dry Van', vin: '', plate: '', year: '', make: '', length: '', status: 'Active', notes: '', createdAt: null };
}

export const TRAILER_TYPES = ['Dry Van', 'Reefer', 'Flatbed', 'Step Deck', 'Lowboy', 'Tanker', 'Container Chassis', 'Dump', 'Other'];

export async function getTrailers() {
  const all = await tx('readonly', (os) => new Promise((res) => {
    const out = [];
    os.openCursor().onsuccess = (e) => { const c = e.target.result; if (c) { out.push(c.value); c.continue(); } else res(out); };
  }));
  return all.sort((a, b) => (a.unit || '').localeCompare(b.unit || ''));
}

export async function saveTrailer(t) {
  const rec = { ...t };
  if (!rec.id) { rec.id = `T${Date.now()}`; rec.createdAt = new Date().toISOString(); }
  await tx('readwrite', (os) => os.put(rec));
  return rec;
}

export const deleteTrailer = (id) => tx('readwrite', (os) => os.delete(id));
